import { render, staticRenderFns } from "./RealizarVenda.vue?vue&type=template&id=35e4d2fa"
import script from "./RealizarVenda.vue?vue&type=script&lang=js"
export * from "./RealizarVenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports